var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4047 2.6402C16.2904 2.5611 16.1572 2.5136 16.0186 2.50251C15.8801 2.49143 15.741 2.51715 15.6156 2.57706L2.19993 8.89031C2.0632 8.95541 1.94808 9.05848 1.86832 9.18721C1.78856 9.31595 1.74753 9.46491 1.75012 9.61633C1.75262 9.76766 1.79859 9.91507 1.88255 10.041C1.9665 10.1669 2.08489 10.2661 2.22361 10.3266L6.49294 12.1969V17.5L11.1016 14.2092L14.858 15.8507C14.9566 15.8975 15.0645 15.9218 15.1737 15.9217C15.3187 15.9207 15.4607 15.8797 15.584 15.8033C15.6927 15.7375 15.7838 15.6465 15.8498 15.538C15.9157 15.4295 15.9545 15.3066 15.9628 15.1799L16.752 3.34255C16.7603 3.20538 16.7326 3.06842 16.6717 2.94524C16.6108 2.82205 16.5188 2.7169 16.4047 2.6402ZM14.4634 13.9567L10.3046 12.1337L12.8062 7.24098L6.76915 10.5949L4.45692 9.57688L15.0868 4.57363L14.4634 13.9567Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperPlane);
export default __webpack_public_path__ + "static/media/icon-paper-plane.1c28ee4e9dc5829c2ba72dfe0d75babe.svg";
export { ForwardRef as ReactComponent };